import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { Stack, Typography, Button, Paper } from '@mui/material';
import dayjs from 'dayjs';
import AccordionSection from '../AccordionSection';
import { downloadInvoice } from '@shared/components/InvoicePdf';
import { Invoice, getDate } from '@shared/entity';

type InvoicesSectionProps = { invoices?: Invoice[] };
const InvoicesSection = ({ invoices }: InvoicesSectionProps) => {
  const { t } = useIntlTranslations();
  return (
    <AccordionSection
      id="profile-invoices"
      title={t('myProfile.invoices')}
      subtitle={t('myProfile.invoicesSubtitle')}
    >
      <Stack spacing={1}>
        {!invoices?.length && (
          <Typography color="text.secondary">{t('myProfile.noInvoices')}</Typography>
        )}
        {[...(invoices || [])]
          .sort((a, b) => new Date(b.issuedAt).getTime() - new Date(a.issuedAt).getTime())
          .map(invoice => (
            <Paper variant="outlined" key={invoice.invoiceNumber} sx={{ p: 2, borderRadius: 2 }}>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                gap={2}
                justifyContent="space-between"
                alignItems={{ sm: 'center' }}
              >
                <Stack spacing={0.5}>
                  <Typography fontWeight={600}>
                    {invoice.invoiceNumber} · {Number(invoice.amount) / 100} {invoice.currency}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {getDate(dayjs(invoice.issuedAt).toDate())}
                  </Typography>
                  {invoice.notes && <Typography variant="body2">{invoice.notes}</Typography>}
                </Stack>
                <Button
                  variant="outlined"
                  sx={{ flexShrink: 0 }}
                  onClick={() => downloadInvoice(invoice)}
                >
                  {t('myProfile.downLoadInvoice')}
                </Button>
              </Stack>
            </Paper>
          ))}
      </Stack>
    </AccordionSection>
  );
};
export default InvoicesSection;
